<template>
  <Card :title="$t('claims.noClaims.title')">
    <template v-slot:content>
      <p v-html="$t('claims.noClaims.text')" class="mb-24"></p>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { Card } from 'de-zurich-ui-library'
</script>

<style scoped lang="scss">
/* No styles */
</style>
